import { useFadeIn } from '@/hooks/useFadeIn';
import { differentiators } from '@/mocks/homeData';

function FadeCard({ item, index }: { item: typeof differentiators[0]; index: number }) {
  const { ref, isVisible } = useFadeIn(0.1);
  return (
    <div
      ref={ref}
      className={`group bg-background-100 rounded-xl p-6 md:p-8 text-center card-hover fade-section ${isVisible ? 'is-visible' : ''}`}
      style={{ transitionDelay: `${index * 100}ms` }}
    >
      <div className="w-14 h-14 mx-auto mb-5 flex items-center justify-center bg-accent-50 rounded-xl transition-colors duration-500 group-hover:bg-accent-100">
        <i className={`${item.icon} text-accent-600 text-2xl`}></i>
      </div>
      <h3 className="font-heading text-lg font-bold text-foreground-950 mb-3">
        {item.title}
      </h3>
      <p className="text-foreground-500 text-sm leading-relaxed">
        {item.description}
      </p>
    </div>
  );
}

export default function DifferentiatorsSection() {
  const { ref: headerRef, isVisible: headerVisible } = useFadeIn(0.15);

  return (
    <section id="diferenciais" className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div
          ref={headerRef}
          className={`text-center mb-14 fade-section ${headerVisible ? 'is-visible' : ''}`}
        >
          <span className="text-xs uppercase tracking-[0.2em] text-accent-600 font-semibold mb-3 block">
            Por que nos escolher
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight max-w-2xl mx-auto">
            Excelência que vai além do sorriso
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {differentiators.map((item, index) => (
            <FadeCard key={item.title} item={item} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
}